import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Shirt, Upload, Sparkles } from "lucide-react";
import Navbar from "../components/Navbar";
import AutoCarousel from "../components/AutoCarousel";

// ─────────────────────────────────────────────────────────────
// "Authentic Vintage as Seen Here" carousel photos.
// To change the ORDER, simply move the lines up or down.
// To swap a photo, replace its URL. Add/remove lines freely.
// ─────────────────────────────────────────────────────────────
const AUTHENTIC_VINTAGE_PHOTOS = [
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/0dr26og9_Screenshot%202025-11-06%20070815.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/s4mi9508_2.jpg", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/qtcyzvjl_Screenshot%202026-08-02%20182555.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/ydawba6t_Screenshot%202026-09-11%20232012.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/l71hrqbr_26992120_1582927415129711_9026649813729963574_n.jpg" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/800yzbu1_71919634_2458129974276113_4375654445703233536_n.jpg" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/nqezzvji_Screenshot%202026-09-11%20231338.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/t55s08wm_Screenshot%202026-09-11%20231731.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/wescffqo_Screenshot%202026-09-12%20002651.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/ehug7824_Screenshot%202026-09-11%20231303.png" },
  { src: "https://static.prod-images.emergentagent.com/jobs/2ce4e414-33fd-4f8e-8f51-014294dee4e4/images/ae3f1375c5cba1ca4645fb2aac503ce9acd1bb8968830899692f1a65006220cf.jpeg", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/zf0ghzo1_Screenshot%202026-09-11%20231614.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/1iwjkt0z_Screenshot%202026-09-11%20231745.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/fl3dvv6h_Screenshot%202026-09-11%20231630.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/s7y8sdrv_Screenshot%202026-09-11%20231604.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/vjysf4my_Screenshot%202026-09-11%20231659.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/9y7ukfl4_Screenshot%202026-09-11%20231832.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/cs4teezr_Screenshot%202026-09-11%20231650.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/mjew1ait_10.jpg" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/8uto5rqe_Screenshot%202026-09-11%20231711.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/0m8zomba_Screenshot%202026-09-11%20231543.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/fi4klb7u_Screenshot%202026-09-11%20232053.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/h4odrvia_11.jpg" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/5icdxjgg_Screenshot%202026-09-11%20231720.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/3psjsgr1_Screenshot%202026-09-11%20232137.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/s4qodky6_Screenshot%202026-09-11%20232123.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/xe7scmpo_12.jpg", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/7fazn3i7_Screenshot%202026-09-12%20000127.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/295vv8ck_Screenshot%202026-09-11%20235523.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/x6blh535_Screenshot%202026-09-11%20235504.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/g4tknav7_Screenshot%202025-11-12%20153852.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/emlg32ha_Screenshot%202026-09-12%20001322.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/hsyb8qxo_Screenshot%202026-09-12%20001507.png", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/kjfdpn9t_Screenshot%202026-09-11%20235008.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/lxt8pwm4_Screenshot%202025-06-08%20081840.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/rh0llir1_Screenshot%202026-09-12%20002714.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/pa5hsy1y_Screenshot%202026-09-12%20001613.png", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/dt2jn0ug_Screenshot%202026-09-12%20001455.png", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/p5rult48_Screenshot%202026-09-11%20231244.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/vi998nvu_Screenshot%202026-09-12%20003005.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/5vrsh00s_1073170_489672244455239_1602604667_o.webp" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/0p3afj5p_Screenshot%202026-09-11%20231459.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/03i642is_Screenshot%202026-09-12%20001337.png", pos: "left bottom" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/87zyzoow_11164709_826407067448420_6018043696859593661_n.jpg" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/dtqbgkcr_Screenshot%202026-09-15%20125654.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/t9eosdam_Screenshot%202025-11-07%20212133.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/f89k67to_Screenshot%202026-09-12%20000015.png" },
  { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/0e6yo5m9_Screenshot%202026-09-12%20002703.png" },
];

// Small editorial eyebrow label shared across every section.
const Eyebrow = ({ children, testid }) => (
  <p data-testid={testid} className="text-xs uppercase tracking-[0.4em] text-[#8B5A2B] text-center mb-8">
    {children}
  </p>
);

export default function Catalog() {
  const [design, setDesign] = useState("");

  const chips = [
    { label: "Victorian-Coquette", key: "victorian" },
    { label: "Prairie-Retro", key: "prairie" },
    { label: "Wedding", key: "wedding" },
    { label: "Design Your Own", key: "custom" },
  ];

  return (
    <div className="relative z-10 min-h-screen">
      <Navbar />

      {/* ── SEGMENT · Slideshow + Authentic Vintage (coloured) ─── */}
      <section data-testid="section-collection" className="bg-[#F4F1EA] px-6 md:px-16 pt-14 pb-16 md:pb-20">
        <AutoCarousel images={AUTHENTIC_VINTAGE_PHOTOS} fit="contain" />

        <div className="max-w-2xl mx-auto text-center mt-10">
          <h1 className="font-serif-display text-3xl md:text-4xl leading-tight">
            Authentic Vintage Fashion, Chosen with Photography in Mind.
          </h1>
        </div>
      </section>

      {/* ── SEGMENT · The Collection + buttons (plain) ─────────── */}
      <section data-testid="section-collection-chips" className="bg-[#FDFBF7] px-6 md:px-16 py-14">
        <Eyebrow testid="eyebrow-collection">The Collection</Eyebrow>

        <div className="flex flex-wrap justify-center gap-3">
          {chips.map((c) => (
            <Link
              key={c.label}
              to={`/try-on?c=${c.key}`}
              data-testid={`filter-${c.label.toLowerCase()}`}
              className="text-sm px-4 py-2 rounded-full border border-[#1A1A1A]/20 text-[#4A4A4A] hover:bg-[#1A1A1A] hover:text-[#FDFBF7] hover:border-[#1A1A1A] transition-colors duration-300"
            >
              {c.label}
            </Link>
          ))}
        </div>
      </section>

      {/* ── SECTION II · How It Works ──────────────────────────── */}
      <section data-testid="section-how-it-works" className="border-t border-[#1A1A1A]/10 bg-[#F4F1EA] px-6 md:px-16 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h1 data-testid="catalog-search" className="font-serif-display text-3xl md:text-4xl leading-tight text-[#1A1A1A]">
            Making Vintage Fashion Accessible to Everyone
          </h1>
        </div>

        <Eyebrow testid="eyebrow-how-it-works">How It Works</Eyebrow>

        <p data-testid="step-1-label" className="text-xs uppercase tracking-[0.4em] text-[#8B5A2B] text-center mb-8">1. Try on an Original</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {[
            { n: "01", icon: Shirt, title: "Choose", text: "Browse the collection and choose the vintage piece that you'd love to see yourself in." },
            { n: "02", icon: Upload, title: "Upload Photo", text: "Upload a clear photo of yourself - full or half body." },
            { n: "03", icon: Sparkles, title: "Receive Your Look", text: "Our AI returns a photorealistic image of you wearing the garment." },
          ].map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`step-box-${i + 1}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="rounded-2xl border border-[#1A1A1A]/10 bg-[#FDFBF7] p-7 text-center flex flex-col items-center hover:border-[#6D214F]/40 transition-colors duration-300"
            >
              <div className="flex flex-col items-center mb-4">
                <span className="font-serif-display text-3xl text-[#E0D2C0] mb-2">{s.n}</span>
                <s.icon className="w-6 h-6 text-[#6D214F]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif-display text-2xl mb-4">{s.title}</h3>
              <Link
                to="/try-on"
                data-testid={`step-tryon-${i + 1}`}
                className="inline-flex items-center justify-center bg-[#1A1A1A] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] px-6 py-2.5 rounded-full hover:bg-[#6D214F] transition-colors duration-300"
              >
                Try it on
              </Link>
              <p className="text-sm text-[#4A4A4A] leading-relaxed mt-4">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ── SEGMENT · Describe your own design (coloured) ─────── */}
      <section data-testid="section-design-your-own" className="border-t border-[#1A1A1A]/10 bg-[#F4F1EA] px-6 md:px-16 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center mb-8">
          <p data-testid="or-start-original-text" className="text-xs uppercase tracking-[0.3em] text-[#8B5A2B]">2. Start with an Original and Make it Your Own</p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {[
            { img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/otxccl0p_thenewblack-cff3057a-9571-4d23-b699-ba25f5088302%20%281%29.jpg", label: "Original" },
            { img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/8rrg9msd_thenewblack-1a0b5320-e5fd-4149-9951-b9d739cd24db.jpg", label: "Your Own Design" },
            { img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/hdaulxmo_thenewblack-bc2dd05d-3609-4467-b9a1-02f32a0bb7a4.jpg", label: "Original" },
            { img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/ce9krcys_thenewblack-b70b846c-e86b-4455-abfb-4f88cf6b8e96.jpg", label: "Your Own Design" },
            { img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/jo9npq8j_thenewblack-8e4819f8-6a8d-44d7-b7b5-f5737fcfcdb0%20%282%29.jpg", label: "Original" },
            { img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/imtvlp3g_thenewblack-91913be3-1fcb-4a68-a61c-9c4b1d3884e7.jpg", label: "Your Own Design" },
          ].map((b, i) => (
            <div key={i} data-testid={`design-box-${i}`}>
              <figure className="aspect-[9/16] overflow-hidden rounded-xl bg-[#FDFBF7] border border-[#1A1A1A]/10 group">
                {b.img && (
                  <img src={b.img} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[900ms]" />
                )}
              </figure>
              {b.label && (
                <p className="text-center text-[10px] uppercase tracking-[0.25em] text-[#8B5A2B] mt-2">{b.label}</p>
              )}
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto text-center mt-8">
          <p data-testid="upload-favorites-text" className="text-xs uppercase tracking-[0.3em] text-[#8B5A2B]">3. Upload your personal favorites to try on</p>
        </div>

        <div className="max-w-xl mx-auto grid grid-cols-2 gap-4 md:gap-5 mt-6">
          {[
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/dlj3azlj_thenewblack-2dfdde7d-ba0f-4602-813b-4992fecb8a7b.jpg",
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/yag5ofe9_thenewblack-064e68c0-b95b-4dfe-930f-08f7732ca6c3.jpg",
          ].map((src, i) => (
            <figure
              key={i}
              data-testid={`favorite-box-${i}`}
              className="aspect-[9/16] overflow-hidden rounded-xl bg-[#FDFBF7] border border-[#1A1A1A]/10 group"
            >
              <img src={src} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[900ms]" />
            </figure>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mt-12">
          <label className="block text-xs uppercase tracking-[0.3em] text-[#8B5A2B] text-center mb-4">
            4. Describe your own design
          </label>
          <textarea
            data-testid="design-textarea"
            value={design}
            onChange={(e) => setDesign(e.target.value)}
            rows={4}
            placeholder="Write here — a silhouette, an era, a fabric, a feeling…"
            className="w-full bg-[#FDFBF7] border border-[#1A1A1A]/10 rounded-2xl px-5 py-4 text-sm text-[#1A1A1A] placeholder:text-[#4A4A4A]/60 focus:outline-none focus:border-[#6D214F] transition-colors resize-none"
          />
        </div>
      </section>

      {/* ── SECTION · For Everyone (dog) ───────────────────────── */}
      <section data-testid="section-for-everyone" className="border-t border-[#1A1A1A]/10 bg-[#FDFBF7] px-6 md:px-16 py-16 md:py-24">
        <Eyebrow testid="eyebrow-for-everyone">Is virtual try-on really for everyone?</Eyebrow>

        <div className="max-w-2xl mx-auto text-center mb-10">
          <p data-testid="everyone-text" className="font-serif-display text-3xl md:text-4xl leading-tight text-[#1A1A1A]">
            Yes, Everyone...
          </p>
        </div>

        <div className="w-full max-w-[216px] mx-auto">
          <figure
            data-testid="everyone-photo"
            className="aspect-[9/16] overflow-hidden rounded-xl bg-[#1A140F] group"
          >
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/v40takun_thenewblack-1174f67b-12f8-4038-914e-e4465e3a426c.jpg"
              alt=""
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[900ms]"
            />
          </figure>
        </div>
      </section>

      {/* ── SECTION IV · Re-Style, Not Re-Shoot ────────────────── */}
      <section data-testid="section-restyle" className="border-t border-[#1A1A1A]/10 bg-[#F4F1EA] px-6 md:px-16 py-16 md:py-24">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <h1 className="font-serif-display text-3xl md:text-4xl leading-tight">No Need for a Re-Shoot. Just Re-Style.</h1>
        </div>

        <div className="max-w-2xl mx-auto grid grid-cols-2 gap-4 md:gap-6">
          {[
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/ederuvqc_thenewblack-9421401d-4891-4cb8-bb24-e7798a311308.jpg",
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/0cb200gt_thenewblack-a290d624-1244-4705-b4ff-70ba8fffc94f.jpg",
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/x2jq5f83_thenewblack-c155335e-5ac6-40c4-a6be-c662f2e4ae67.jpg",
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/r51omsma_thenewblack-b389066a-0728-40c9-81e3-fb501a160816.png",
          ].map((src, i) => (
            <figure
              key={i}
              data-testid={`gallery-photo-${i}`}
              className="aspect-[9/16] overflow-hidden rounded-xl bg-[#F4F1EA] group"
            >
              <img src={src} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[900ms]" />
            </figure>
          ))}
        </div>
      </section>

      {/* ── SECTION · Closing tagline + CTA (plain) ────────────── */}
      <section data-testid="section-tryons" className="border-t border-[#1A1A1A]/10 bg-[#FDFBF7] px-6 md:px-16 py-16 md:py-20">
        <div className="max-w-2xl mx-auto text-center">
          <p data-testid="tryons-tagline" className="font-serif-display text-3xl md:text-4xl leading-tight text-[#1A1A1A]">
            Hundreds of Authentic Vintage Pieces, Unlimited Possibilities and Yours to Re-Imagine.
          </p>

          <Link
            to="/try-on"
            data-testid="tryons-cta"
            className="inline-flex items-center justify-center mt-8 bg-[#1A1A1A] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] px-8 py-3.5 rounded-full hover:bg-[#6D214F] transition-colors duration-300"
          >
            Try It On
          </Link>
        </div>
      </section>
    </div>
  );
}
